/* eslint-disable */
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import ChangeUrlOptionsVM from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeUrlOptions';
import template from '@bingads-webui-static-legacy/bulk-edit/template/shared/changeUrlOptions.pug';
import actionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeUrlOptionsActions';
import trackingTemplateActionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/trackingTemplateActions';
import customParametersActionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/customParametersActions';
import finalUrlSuffixActionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/finalUrlSuffixActions';
import entityTitleKeys from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/entityTitleKeys';
import entityProgressTextMap from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/entityProgressText';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import customParamsGridTemplate from '@bingads-webui-static-legacy/bulk-edit/view/shared/customParams-inline';
import urlOptionsFields from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/urlOptionsFields';
import options from '@bingads-webui-static-legacy/schema/bulkEdit/textActionOptions';
import * as upgradeUrl from '@bingads-webui-campaign/upgrade-url';
import * as safeJSON from '@bingads-webui/safe-json';
import escapeHelper from '@bingads-webui-static-legacy/bulk-edit/view/escapeHelper';
import * as instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import * as bulkOperationBase from '@bingads-webui-campaign/bulk-operation-base';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var allowedEntities = ['Campaign', 'AdGroup', 'Keyword', 'Ad'];
var helper = function (value, defaultValue) {
  var obj = safeJSON.parseSync(value);
  if (_.isEmpty(obj)) {
    return defaultValue;
  } else {
    obj = _.map(obj, function (item) {
      var param = safeJSON.parseSync(item);
      _.each(param, function (val, key) {
        param[key] = escapeHelper.escape(val);
      });
      return param;
    });
    return customParamsGridTemplate({
      UrlCustomParametersJson: JSON.stringify({
        Parameters: obj
      })
    });
  }
};
var formatUrlOptions = function (rows, entityType, urlOptionsDisplay) {
  if (!rows) {
    return null;
  }
  _.each(rows, function (row) {
    var defaultValue = '--';
    var pair, oldTrackingTemplate, newTrackingTemplate, oldCustomParams, newCustomParams, oldFinalUrlSuffix, newFinalUrlSuffix;
    oldTrackingTemplate = newTrackingTemplate = oldCustomParams = newCustomParams = oldFinalUrlSuffix = newFinalUrlSuffix = defaultValue;
    row.data = [];
    var entityValues = {};
    _.each(row.EntityKey, function (entity) {
      entityValues[entity.Key] = entity.Value;
    });
    var firstCell = {
      value: '',
      isHtml: false
    };
    if (entityType === 'Ad') {
      firstCell = bulkOperationBase.getAdEntityPreviewCell(entityValues, i18n);
    } else {
      pair = _.find(row.EntityKey, function (item) {
        return item.Key === entityTitleKeys[entityType];
      });
      firstCell.value = pair ? pair.Value : '';
    }
    row.data.push(firstCell);
    _.each(row.Changes, function (change) {
      if (change.Property === entityProgressTextMap[entityType].TrackingTemplateProperty) {
        oldTrackingTemplate = change.OriginalValue || defaultValue;
        newTrackingTemplate = change.NewValue || defaultValue;
        if (urlOptionsDisplay.trackingTemplate) {
          row.data.push({
            value: oldTrackingTemplate,
            isHtml: false
          });
          row.data.push({
            value: newTrackingTemplate,
            isHtml: false
          });
        }
      } else if (change.Property === entityProgressTextMap[entityType].FinalUrlSuffixProperty) {
        oldFinalUrlSuffix = change.OriginalValue || defaultValue;
        newFinalUrlSuffix = change.NewValue || defaultValue;
        if (urlOptionsDisplay.finalUrlSuffix) {
          row.data.push({
            value: oldFinalUrlSuffix,
            isHtml: false
          });
          row.data.push({
            value: newFinalUrlSuffix,
            isHtml: false
          });
        }
      } else {
        oldCustomParams = helper(change.OriginalValue, defaultValue);
        newCustomParams = helper(change.NewValue, defaultValue);
        if (urlOptionsDisplay.customParameters) {
          row.data.push({
            value: oldCustomParams,
            isHtml: true
          });
          row.data.push({
            value: newCustomParams,
            isHtml: true
          });
        }
      }
    });
  });
  return rows;
};
var view = BaseView.extend({
  initialize: function (options) {
    var scenarioName = 'bulkEditUrlOptions' + options.entityType;
    var senario = instrumentation.default[scenarioName].create();
    var activity = senario[scenarioName].create();
    activity.start();
    options.activity = activity;
    var selectedRows = gridHelper.getSelectedRows(options.grid);
    var hasExtaSelected = _.find(selectedRows, row => {
      return row.Type === 'ExpandedText';
    }) || options.entityType === 'Ad' && gridHelper.isCrossPageAllSelected(options.grid);
    const permissions = config.get('Permissions') || ({});
    BaseView.prototype.initialize.call(this, options);
    this.model.set('Entity', options.entityType);
    this.ko_model = new ChangeUrlOptionsVM(this.model, {
      entityType: options.entityType,
      showExtaWarningMessage: !permissions.IsWhiteListEXTAEnabled && hasExtaSelected
    });
    this.template = template;
    this.entityType = options.entityType;
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    this.ko_model.customParametersSelectedAction.subscribe(function (newValue) {
      this.ko_model.showCustomParamsInput(newValue !== customParametersActionTypes.removeAll);
      switch (newValue) {
        case customParametersActionTypes.add:
        case customParametersActionTypes.replaceAll:
          this.customParams.goToAddReplaceMode();
          break;
        case customParametersActionTypes.removeContaining:
        case customParametersActionTypes.removeExact:
          this.customParams.goToRemoveMode();
          break;
      }
    }, this);
    this.customParams = new upgradeUrl.CustomParametersView({
      i18n: i18n,
      permissions: config.get('Permissions') || ({}),
      bulkEditMode: true,
      entityType: this.entityType,
      bulkEditShowAddLabel: true,
      bulkEditShowMatchCase: false
    }).render();
    this.$('.custom-parameters-container').html(this.customParams.$el);
    this.ko_model.isDisabled.subscribe(function (newValue) {
      this.customParams.setDisabled(newValue);
    }, this);
    return this;
  },
  createBaseActionObject: function (odataType, property, actionType) {
    return {
      '@odata.type': odataType,
      Property: property,
      ActionType: actionType
    };
  },
  setAction: function () {
    var action = {
      Actions: []
    };
    var selectedAction = this.ko_model.selectedAction();
    var customParamsValues = this.customParams.getValues(true);
    var actionIdx = 0;
    switch (selectedAction) {
      case actionTypes.set:
        if (this.ko_model.trackingTemplateSelectedAction() === trackingTemplateActionTypes.remove || !_.isEmpty(this.ko_model.trackingTemplate().trim())) {
          action.Actions[actionIdx] = this.createBaseActionObject('#Model.TextAction', urlOptionsFields.trackingTemplate, trackingTemplateActionTypes.set);
          _.extend(action.Actions[actionIdx], {
            Value: this.ko_model.trackingTemplateSelectedAction() === trackingTemplateActionTypes.set ? this.ko_model.trackingTemplate().trim() : '',
            Options: options.None
          });
          actionIdx++;
        }
        if (!_.isEmpty(this.ko_model.finalUrlSuffix().trim())) {
          action.Actions[actionIdx] = this.createBaseActionObject('#Model.TextAction', urlOptionsFields.finalUrlSuffix, finalUrlSuffixActionTypes.set);
          _.extend(action.Actions[actionIdx], {
            Value: this.ko_model.finalUrlSuffix().trim(),
            Options: options.None
          });
          actionIdx++;
        }
        if (this.ko_model.customParametersSelectedAction() === customParametersActionTypes.removeAll || customParamsValues.params.length > 0) {
          var matchOptions = options.None, value = [], actionType = 'Remove';
          value = _.map(customParamsValues.params, function (item) {
            return JSON.stringify(item);
          });
          switch (this.ko_model.customParametersSelectedAction()) {
            case customParametersActionTypes.add:
              actionType = 'Add';
              break;
            case customParametersActionTypes.removeAll:
              actionType = 'Set';
              value = [];
              break;
            case customParametersActionTypes.replaceAll:
              actionType = 'Set';
              break;
            case customParametersActionTypes.removeContaining:
              matchOptions = customParamsValues.matchCase ? options.MatchCase : options.None;
              break;
            case customParametersActionTypes.removeExact:
              matchOptions = customParamsValues.matchCase ? options.MatchWholeWord + ',' + options.MatchCase : options.MatchWholeWord;
              break;
          }
          action.Actions[actionIdx] = this.createBaseActionObject('#Model.ListAction', urlOptionsFields.customParameters, actionType);
          _.extend(action.Actions[actionIdx], {
            Value: value,
            MatchOptions: matchOptions
          });
          actionIdx++;
        }
        break;
      case actionTypes.findReplace:
        var findText = this.ko_model.findText().trim();
        var replaceText = this.ko_model.replaceText().trim();
        var property = this.ko_model.selectedField();
        var actionOptions = this.ko_model.findReplaceOptions();
        var selectedOptions = actionOptions && actionOptions.length ? actionOptions.join() : options.None;
        if (!_.isEmpty(findText)) {
          action.Actions[actionIdx] = this.createBaseActionObject('#Model.TextAction', property, selectedAction);
          _.extend(action.Actions[actionIdx], {
            SearchString: findText,
            Value: replaceText,
            Options: selectedOptions
          });
          actionIdx++;
        }
        break;
      case actionTypes.append:
        var appendText = this.ko_model.appendText().trim();
        var property = this.ko_model.selectedField();
        var actionOptions = this.ko_model.changeTextOption();
        if (!_.isEmpty(appendText)) {
          action.Actions[actionIdx] = this.createBaseActionObject('#Model.TextAction', property, actionOptions);
          _.extend(action.Actions[actionIdx], {
            SearchString: '',
            Value: appendText,
            Options: options.None
          });
          actionIdx++;
        }
        break;
    }
    this.model.set('BatchAction', action);
  },
  getIdFilter: function () {
    var ret = {};
    if (_.contains(allowedEntities, this.entityType)) {
      ret = filterHelper.getIdFilter(this.grid, this.entityType);
    }
    return ret;
  },
  getProgressText: function () {
    return i18n.getString(entityProgressTextMap[this.entityType].ProgressText) || '';
  },
  formatGridResults: function (data) {
    var previewGrids = [];
    var errorsGrids = [];
    var urlOptionsDisplay = {
      trackingTemplate: false,
      finalUrlSuffix: false,
      customParameters: false
    };
    var actions = this.model.get('BatchAction').Actions;
    if (actions.length > 0) {
      previewGrids.push(this.ko_model.entityHeaderName());
      errorsGrids.push(this.ko_model.entityHeaderName());
    }
    for (var i = 0; i < actions.length; i++) {
      var action = actions[i];
      var property = action.Property;
      if (property === urlOptionsFields.trackingTemplate) {
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentTrackingTemplate'));
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_NewTrackingTemplate'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentTrackingTemplate'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_AttemptedNewTrackingTemplate'));
        urlOptionsDisplay.trackingTemplate = true;
      } else if (property === urlOptionsFields.finalUrlSuffix) {
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentFinalUrlSuffix'));
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_NewFinalUrlSuffix'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentFinalUrlSuffix'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_AttemptedNewFinalUrlSuffix'));
        urlOptionsDisplay.finalUrlSuffix = true;
      } else if (property && property.indexOf(urlOptionsFields.customParameters) > -1) {
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentCustomParameters'));
        previewGrids.push(i18n.getString('BulkEdit_UrlOptions_NewCustomParameters'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_CurrentCustomParameters'));
        errorsGrids.push(i18n.getString('BulkEdit_UrlOptions_AttemptedNewCustomParameters'));
        urlOptionsDisplay.customParameters = true;
      }
    }
    if (previewGrids.length > 0) {
      this.ko_model.previewGrids(previewGrids);
      this.ko_model.errorsGrids(errorsGrids);
      this.ko_model.showPreview(true);
    }
    if (actions.length > 0) {
      var numberOfActions = actions.length;
      var propertiesToChange = null;
      var changesToPatch = [];
      _.each(data, function (entityChange) {
        if (entityChange.Changes.length < numberOfActions) {
          changesToPatch.push(entityChange);
        } else if (!propertiesToChange) {
          propertiesToChange = _.map(entityChange.Changes, function (change) {
            return change.Property;
          });
        }
      });
      if (changesToPatch.length > 0) {
        _.each(changesToPatch, function (entityChange) {
          var presentChanges = _.reduce(entityChange.Changes, function (memo, change) {
            memo[change.Property] = change;
            return memo;
          }, {});
          var patchedChanges = [];
          _.each(propertiesToChange, function (property) {
            if (!presentChanges[property]) {
              patchedChanges.push({
                Property: property,
                NewValue: null,
                OriginalValue: null
              });
            } else {
              patchedChanges.push(presentChanges[property]);
            }
          });
          entityChange.Changes = patchedChanges;
        });
      }
    }
    return formatUrlOptions(data, this.entityType, urlOptionsDisplay);
  },
  formatPreviewResults: function (results) {
    return this.formatGridResults(results);
  },
  formatErrors: function (errors) {
    return this.formatGridResults(errors);
  },
  transformErrors: function (errors) {
    if (errors) {
      _.each(errors, function (error) {
        if (error.Error === 'TooMuchText') {
          error.message = error.message.replace('{0}', i18n.getString('BulkEdit_Property_DestinationUrl')).replace('{1}', 1024);
        }
      });
    }
  }
});
export default view;

